import { jsDebug } from "../util/classes";
import { UTL } from "../util/classes";
import { TRANS } from "../util/classes";

export function i_am_local_function(): void {
    alert("i_am_local_function()");
}

export function testEgPswd(): void {
    alert("Hello from x.js.test()");
}



export async function cmux_event_is_locked_old_delme(event_code: number): Promise<boolean> {
    const token: string = UTL.ASP_GetAntiForgeryToken();
    alert(`token=${token}`);
    const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
    fetch_options.method = "POST";
    fetch_options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': token };
    const url_str: string = `/cmux/event_is_locked/${event_code}`;
    let response = await fetch(url_str, fetch_options);
    const REC = await response.json();
    return REC.event_is_locked;
}


export async function cmux_event_is_locked(event_code: number): Promise<boolean> {
    const token: string = UTL.ASP_GetAntiForgeryToken();
    const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
    fetch_options.method = "POST";
    fetch_options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': token };
    const url_str: string = `/cmux/event_is_locked/${event_code}`;
    let response = await fetch(url_str, fetch_options);
    const REC = await response.json();
    return REC.event_is_locked;
}


export async function cmux_change_locked_status_for_event(event_code: number, bval: boolean): Promise<void> {
    const bval_as_str: string = String(bval);
    //let data: a_ny = new Object();
    //data.event_code = event_code;
    const token: string = UTL.ASP_GetAntiForgeryToken();
    const fetch_options = {} as RequestInit; // remember that RequestInit is an interface for  fetch options
    fetch_options.method = "POST";
    fetch_options.headers = { 'Content-Type': 'application/json', 'RequestVerificationToken': token };
    const url_str: string = `/cmux/set_bool_in_event_lock/${event_code}/${bval_as_str}/`;
    // responce שים לב שהפעולה הזאת אינה מחזירה דבר לכן אין הצבה ל
    // responce שים לב שהפעולה הזאת אינה מחזירה דבר לכן אין הצבה ל
    // responce שים לב שהפעולה הזאת אינה מחזירה דבר לכן אין הצבה ל
    await fetch(url_str, fetch_options);
}


export async function goto_cumx_support_page(): Promise<void> {
    const form: HTMLFormElement = document.createElement('form');
    form.action = "/cmux/cmux_support/";
    form.method = "GET"; // i.e. "GET" or "POST"
    const token: string = UTL.ASP_GetAntiForgeryToken(); // הוספת השורה הזו
    UTL.add_hidden_input_to_form(form, "__RequestVerificationToken", token);
    UTL.add_hidden_input_to_form(form, "viewport", `${window.innerWidth}x${window.innerHeight}`)
    document.body.appendChild(form);
    form.submit();
}


export async function cmux_refresh_site(): Promise<void> {
    // should be delete 20-7-25
    alert("refresh_site() for this moment is not implemented");
}


export const cmux_general_wrapper = {
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    i_am_local_function,
    testEgPswd,
    cmux_event_is_locked_old_delme,
    cmux_event_is_locked,
    cmux_change_locked_status_for_event,
    goto_cumx_support_page,
    cmux_refresh_site
};


